import React, { Component, Fragment } from "react";
import * as d3 from "d3";
import ContainerDimensions from "react-container-dimensions";
import NewPie from "../../../../../d3Components/NewPieChart/pie";
import "./pieContent.scss";

class Piecontent extends Component {
  _isMounted = false;
  state = {
    isLoading: true,
    newPieData: [],
    obj: [],
    newPie: []
  };

  dataModify = newPieData => {
    let obj = {};
    for (var i in newPieData) {
      if (!obj[newPieData[i]["fund"]]) {
        obj[newPieData[i]["fund"]] = newPieData[i]["allocation"];
      } else {
        obj[newPieData[i]["fund"]] =
          parseFloat(newPieData[i]["allocation"]) + obj[newPieData[i]["fund"]];
      }
    }
    let arr = [];
    for (let i in obj) {
      arr.push({ label: i, value: obj[i] });
    }
    this.setState({
      isLoading: false,
      newPieData: newPieData,
      obj,
      newPie: arr
    });
  };

  componentDidMount() {
    const { newPieData } = this.props;

    if (newPieData.length > 0) {
      this.dataModify(newPieData);
    }
  }
  componentWillReceiveProps(props) {
    const { newPieData } = props;

    if (JSON.stringify(newPieData) !== JSON.stringify(this.props.newPieData)) {
      this._isMounted = true;
      this.dataModify(newPieData);
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { newPieData, obj, newPie } = this.state;
    const interpolate = d3.interpolateRgb("#3c4694", "#E8E9F6");

    return (
      <Fragment>
        {newPieData.length > 0 && (
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <h4 className="text-uppercase bold">
              Holdings And Asset class Exposure
            </h4>
            <div style={{ overflow: "auto" }}>
              {newPieData.length ? (
                <ContainerDimensions>
                  {({ width }) => (
                    <Fragment>
                      {width > 0 ? (
                        <NewPie
                          width={width - 40}
                          height={400}
                          id={"Pie1"}
                          color1={"#3c4694"}
                          color2={"#E8E9F6"}
                          data={newPie}
                        />
                      ) : null}
                    </Fragment>
                  )}
                </ContainerDimensions>
              ) : null}
              {Object.keys(obj).length ? (
                <div className="table-grid">
                  {Object.keys(obj).map((d, i) => {
                    return (
                      <div className="table-grid-row" key={`${d}${obj[d] * i}`}>
                        <div>
                          <span
                            style={{
                              color: interpolate(i / Object.keys(obj).length),
                              fontSize: "20px"
                            }}
                          >
                            ●
                          </span>{" "}
                          {d}{" "}
                        </div>
                        <div>{obj[d].toFixed(2)}%</div>
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default Piecontent;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/LiveHoldings/section1/piecontent.jsx